import React from 'react';
import { motion } from 'framer-motion';
import { Users, UserPlus, MessageSquare } from 'lucide-react';

const Team = () => {
  return (
    <div className="min-h-screen p-6">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-4xl font-bold mb-2 text-gray-900">Team</h1>
        <p className="text-lg text-gray-600">Resource allocation, collaboration, and communication tools</p>
      </motion.div>

      <div className="bg-white/70 backdrop-blur-sm rounded-2xl border border-gray-200/50 shadow-lg p-8">
        <div className="text-center">
          <Users className="w-16 h-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold text-gray-900 mb-2">Team</h2>
          <p className="text-gray-600">Resource allocation, collaboration, and communication tools</p>
        </div>
      </div>
    </div>
  );
};

export default Team; 